import React, { useContext, useState } from "react";
import styled from "@emotion/styled";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import profileimg from "../../assets/images/dashboard-image/profile-img.png";
import PersonIcon from "@mui/icons-material/Person";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import {
  logOut,
  selectCurrentUserObject,
  setUserType,
} from "../../store/auth/authSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { ThemeContext } from "../../theme/theme-context/ThemeContext";
import ComponentTitle from "../ComponentTitle";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "transparent",
  backgroundImage: "none !important",
  opacity: 1,
  boxShadow: "none",
  [theme.breakpoints.up("xs")]: {
    width: "100%",
    padding: "0 20px",
    zIndex: "999",
    border: "0",
    backgroundColor: theme.palette.mode === "dark" ? "#243E57" : "#f0f4fb",
    // backgroundColor: "#f0f4fb",
    // background: "#f0f4fb",
    paddingLeft: open ? "260px" : "20px",
    left: "0",
    top: "0",
    boxShadow: "0 0 10px 0 rgba(0,0,0,.2)",
  },
  [theme.breakpoints.up("lg")]: {
    paddingLeft: open ? "260px" : "90px",
  },
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Header = ({ open, handleDrawer, setOpen, title }) => {
  let user = useSelector(selectCurrentUserObject);
  const { dp = "", first_name = "" } = user;
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [anchorEl, setAnchorEl] = useState(false);
  const profileMenu = anchorEl;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const providedTheme = useTheme();

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    dispatch(logOut());
    dispatch(setUserType(null));
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/login", { state: { from: location }, replace: true });
  };

  const handleProfile = async () => {
    navigate("/profile", { state: { from: location }, replace: true });
    setAnchorEl(null);
  };

  const breadcrumbs = [
    <Typography key="1" variant="body1">
      {title}
    </Typography>,
  ];

  return (
    <AppBar position="fixed" open={open} onClick={() => open && setOpen(false)}>
      <Toolbar
        sx={{
          // backgroundColor: providedTheme?.palette?.background?.paper,
          borderRadius: "4px",
          gap: "15px",
          minHeight: "54px !important",
          p: "0 !important",
        }}
      >
        <IconButton
          aria-label="open drawer"
          onClick={handleDrawer}
          edge="start"
          sx={{
            color:
              providedTheme?.palette?.mode === "light"
                ? providedTheme.palette.grey[800]
                : providedTheme.palette.grey[500],
          }}
        >
          <MenuIcon />
        </IconButton>
        <ComponentTitle breadcrumbs={breadcrumbs} />

        <Box
          sx={{
            minHeight: "48px",
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
          }}
        >
          <IconButton onClick={toggleTheme}>
            {theme === "light" ? (
              <DarkModeIcon
                sx={{
                  fill:
                    providedTheme?.palette?.mode === "light"
                      ? providedTheme.palette.grey[800]
                      : providedTheme.palette.grey[500],
                }}
              />
            ) : (
              <LightModeIcon
                sx={{
                  fill:
                    providedTheme?.palette?.mode === "light"
                      ? providedTheme.palette.grey[800]
                      : providedTheme.palette.grey[500],
                }}
              />
            )}
          </IconButton>
          <IconButton>
            <NotificationsNoneIcon
              sx={{
                fill:
                  providedTheme?.palette?.mode === "light"
                    ? providedTheme.palette.grey[800]
                    : providedTheme.palette.grey[500],
                cursor: "pointer",
                width: "28px",
                height: "28px",
              }}
            />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
